// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ia-0";
export var actionModalContentContainer = "_ia-1";
export var createTagButton = "_ia-2";
export var footerContainer = "_ia-7";
export var fullWidthDivider = "_ia-3";
export var hasCreateTagButton = "_ia-4";
export var noCreateTagButton = "_ia-5";
export var tagsContainer = "_ia-6";
export var tagsModalContentContainer = "_ia-8";